// extracted by mini-css-extract-plugin
export default {"wrapper":"sidebarProfile_wrapper__dj4mA","userName":"sidebarProfile_userName__-1Ict","email":"sidebarProfile_email__dq+oW"};